import {
  TASK_NAME,
  TYPE_NAME,
  STATUS_NAME,
  DUEDATE_NAME,
} from "./constant";
import { useController, useForm } from "react-hook-form";
import { EditSummaryFormType } from "./type";
import ControlInputBox from "./createTaskInputField";
import Button from "@/components/Form/Button/Button";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import ControlSelect from "./editFieldSelectBox";
import { useParams } from "react-router-dom";
import { useGetTaskViewDataQuery, useCreateClaimTaskMutation } from "@/services/claimSummary/caseSummaryReducer";
import { useEffect, useState } from "react";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { useCase } from "@/features/case/use-case";
import { useTranslation } from "react-i18next";
import { SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { getOnlyDate, useGetTaskTypeList } from "@/utility/common";
import { dateFunc } from "@/components/Functions/dateFunc";

export const CreateTaskAllInputFields = ({ setShowModal,setDiscardMessage }: any) => {
  const parameter = useParams();
  const {t}=useTranslation();
  const taskListOption=useGetTaskTypeList()
  // const [dueDate, setDueDate] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const caseData = useCase();
  const getDataByUrl = { caseId: caseData.caseId, claimId: parameter?.claimId };
  const { refetch } = useGetTaskViewDataQuery(getDataByUrl);
  const {
    handleSubmit,
    control,
    formState: { errors ,isDirty}  } = useForm<EditSummaryFormType>({
      defaultValues:{
        taskName:"",
        dueDateName:"",
        typeName:"",
        statusName:""
      }
    });
    useEffect(()=>{
      setDiscardMessage(isDirty)
    },[setDiscardMessage,isDirty])
   const { field: dueDateField } = useController({
      name: "dueDateName",
      control,
      rules: {
        required: {
          value: false,
          message: "",
        },
      },
    });
  const [createClaimTask] = useCreateClaimTaskMutation();
  const onSubmit = async (formData: EditSummaryFormType) => {
    let taskData = {
      caseId: caseData.caseId,
      claimId: parameter?.claimId,
      name: formData.taskName,
      dueDate:formData.dueDateName?getOnlyDate(formData.dueDateName?.toString()):getOnlyDate(dateFunc(new Date()).formattedDateOnly),
      status: Number(formData.statusName),
      type: Number(formData.typeName),
    };
    setIsLoading(true);
    const response = await createClaimTask(taskData);
    if (response.hasOwnProperty("data")) {
      refetch();
      setShowModal(false);
      setIsLoading(false);
      setDiscardMessage(false)

    } else {
      setIsLoading(false);
      setShowModal(false);
    }
  };
  // useEffect(() => {
  //   setValue(
  //     DUEDATE_NAME,
  //     new Date(new Date(dueDate || new Date()).toLocaleString("en-US"))
  //       .toISOString()
  //       .substring(0, 10)
  //  );
  // }, [dueDate, setValue]);
  return (
    <>
      <form  onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div  className="motif-col-sm-3 ">
            <div className="form-field">
              <ControlInputBox
                name={TASK_NAME}
                control={control}
                required={true}
                isTextArea={false}
                label={"pages.claims.taskTab.formLabels.taskName"}
                showLabel={true}
              />
              {errors[TASK_NAME] && errors[TASK_NAME].type === "required" && (
                <MotifErrorMessage>
                  {t("pages.claims.taskTab.validationMessages.taskNameReq")}
                </MotifErrorMessage>
              )}
            </div>
          </div>
          <div className="motif-col-sm-3 mar-t-20">
            <div className="form-field">
              <div className="hidedatepicker">
                <ControlInputBox
                  name={DUEDATE_NAME}
                  control={control}
                  required={false}
                  isTextArea={false}
                  label={"pages.claims.taskTab.formLabels.dueDate"}
                  showLabel={true}
                />
              </div>
              <FormattedDatePicker
                todayMark={true}
                //@ts-ignore
                value={dueDateField.value}
                onChange={(value: any) => {
                  dueDateField.onChange(value);
                }}
              />
              {/* {errors[DUEDATE_NAME] && dueDate === undefined && (
                <MotifErrorMessage>
                  {t("pages.claims.taskTab.validationMessages.dueDate")}
                </MotifErrorMessage>
              )} */}
            </div>
          </div>
        {/* </div>
        <div  className="motif-row mar-t-40"> */}
          <div className="motif-col-sm-3  mar-t-20">
            <div className="form-field">
              <ControlSelect
                name={TYPE_NAME}
                //@ts-ignore
                control={control}
                required={true}
                showLabel={true}
                readonly={true}
                label={"pages.claims.taskTab.formLabels.type"}
                placeholder={"placeholder"}
                options={taskListOption}
              />
              {errors[TYPE_NAME] && errors[TYPE_NAME].type === "required" && (
                <MotifErrorMessage>
                  {t("pages.claims.taskTab.validationMessages.typeReq")}
                </MotifErrorMessage>
              )}
            </div>
          </div>
          <div className="motif-col-sm-3  mar-t-20">
            <div className="form-field">
              <ControlSelect
                name={STATUS_NAME}
                //@ts-ignore
                control={control}
                required={true}
                showLabel={true}
                readonly={true}
                label={"pages.claims.taskTab.formLabels.status"}
                options={[
                  {
                    label: t(
                      "pages.claims.taskTab.formLabels.statusLabels.selectStatus"
                    ),
                    value: "",
                  },
                  {
                    value: "0",
                    label: t(
                      "pages.claims.taskTab.formLabels.statusLabels.open"
                    ),
                  },
                  {
                    value: "1",
                    label: t(
                      "pages.claims.taskTab.formLabels.statusLabels.closed"
                    ),
                  },
                  {
                    value: "2",
                    label: t(
                      "pages.claims.taskTab.formLabels.statusLabels.complete"
                    ),
                  },
                ]}
                placeholder="Select Status"
              />
              {errors[STATUS_NAME] &&
                errors[STATUS_NAME].type === "required" && (
                  <MotifErrorMessage>
                    {t("pages.claims.taskTab.validationMessages.statusReq")}
                  </MotifErrorMessage>
                )}
            </div>
          </div>
        </div>
        <div  style={{marginTop:"30px"}} className="mar-t-40">
        <Button
          label={t("global.globalActions.save")}
          variant={SAVE_BUTTON_VARIANT}
          className="motif-button"
          onClickHandler={handleSubmit(onSubmit)}
          type={isLoading ? "loader" : "submit"}
          disabled={isLoading}
        />
        <br></br>
      
        </div>
      </form>
    </>
  );
};
